// Contact details shown on the About Us and Contact Us pages (same as the Home page).
export const SITE_PHONE = '9414004245';
export const SITE_EMAIL = 'manishk004245@gmail.com';
export const SITE_ADDRESS = 'Jaipur, Rajasthan';
export const SITE_MAP_URL = 'https://maps.google.com/?q=Jaipur,+Rajasthan';
